import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <header className="header-section header-gradient">
            <div className="topbar">
                <div className="container">
                    <div className="row align-item-center">
                        <div className="col-md-6">
                           
                        </div>
                    </div>
                </div>
            </div>
            <div className="header-nav">
                <div className="container">
                    <div className="nav-menu bg-white">
                        <div className="row align-items-center">
                            <div className="col-2">
                                <div className="logo-wrapper">
                                    <Link to="/" className="logo-black"><img src="assets/img/logotvplux.svg" alt="logo" className="logo" /></Link>
                                    <Link to="/" className="logo-white"><img src="assets/img/logotvplux.svg" alt="logo" className="logo" /></Link>
                                </div>
                            </div>
                            <div className="col-10 header-right align-items-center justify-content-end">
                                <div className="nav-wrapper">
                                    <nav>
                                        <ul>
                                            <li><a target="_blank" href="https://wa.me/33756756461" className="d-inline"><i className="fa-brands fa-whatsapp"></i> +33 756 756461</a></li>
                                            <li><a className="d-inline"><i className="fa-solid fa-envelope"></i> contact@tvplux.com</a></li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>

                                </div>
                            </div>
                        </div>
            </div>
        </header>
    </>
  );
}
